var map = {
	"./ABL.png": "6871",
	"./BAAC.png": "231d",
	"./BAY.png": "d072",
	"./BBL.png": "c38a",
	"./BCEL.png": "40a8",
	"./CIMBT.png": "7c70",
	"./CITI.png": "fdec",
	"./GHB.png": "1335",
	"./GSB.png": "6bc7",
	"./IBANK.png": "f9f5",
	"./ICBCT.png": "6638",
	"./JDB.png": "c4b1",
	"./KBANK.png": "bf74",
	"./KK.png": "7471",
	"./KKP.png": "cecd",
	"./KTB.png": "db9b",
	"./LDB.png": "56e8",
	"./LHB.png": "85d5",
	"./LHBANK.png": "c687",
	"./MJBL.png": "1111",
	"./SC.png": "b238",
	"./SCB.png": "5450",
	"./TCD.png": "cbc7",
	"./TISCO.png": "1223",
	"./TMN.png": "72ec",
	"./TTB.png": "b692",
	"./UOB.png": "3874",
	"./VINB.png": "fc56"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a24c";